/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type StepUpdateLoanDraftCustomerInfoRequest = {
    referenceId?: string;
    loanId?: string;
    shopId: string;
    customerId?: string;
    citizenId?: string;
    passportNumber?: string;
    firstName?: string;
    lastName?: string;
    phoneNumber?: string;
    citizenAddress?: string;
    currentAddress?: string;
    occupation?: string;
    workPlace?: string;
    email?: string;
    facebookUrl?: string;
    facebookName?: string;
    lineId?: string;
    instagramUrl?: string;
    instagramName?: string;
    tiktokUrl?: string;
    tiktokName?: string;
    firstReferencePersonFirstName: string;
    firstReferencePersonLastName: string;
    firstReferencePersonRelation: string;
    firstReferencePersonPhoneNumber: string;
    secondReferencePersonFirstName?: string;
    secondReferencePersonLastName?: string;
    secondReferencePersonRelation?: string;
    secondReferencePersonPhoneNumber?: string;
    type?: StepUpdateLoanDraftCustomerInfoRequest.type;
    note?: string;
    isImportedByFinancier?: boolean;
};
export namespace StepUpdateLoanDraftCustomerInfoRequest {
    export enum type {
        ONLINE = 'ONLINE',
        OFFLINE = 'OFFLINE',
    }
}

